import type { ExperienceDefinition } from '../types'

// Static registrations of experience definitions.
// Note: These will be implemented in the experiences/ directory next.
import sunrise from '../experiences/Sunrise'
import developerTerminal from '../experiences/DeveloperTerminal'
import clock from '../experiences/Clock'
import missionControl from '../experiences/MissionControl'
import aiCore from '../experiences/AICore'
import progressTimeline from '../experiences/ProgressTimeline'

const registry: Map<string, ExperienceDefinition> = new Map()

// Register standard experience packages
const defaultExperiences: ExperienceDefinition[] = [
  sunrise,
  developerTerminal,
  clock,
  missionControl,
  aiCore,
  progressTimeline,
]

defaultExperiences.forEach((exp) => {
  registry.set(exp.metadata.id, exp)
})

export const ExperienceRegistry = {
  /**
   * Get an experience by ID
   */
  get: (id: string): ExperienceDefinition | undefined => {
    return registry.get(id)
  },

  /**
   * Get all registered experiences
   */
  getAll: (): ExperienceDefinition[] => {
    return Array.from(registry.values())
  },

  /**
   * Register a new experience definition (enables dynamic runtime loading)
   */
  register: (exp: ExperienceDefinition): void => {
    if (registry.has(exp.metadata.id)) {
      console.warn(`[ExperienceRegistry] Duplicate registration for ID: ${exp.metadata.id}`)
      return
    }
    registry.set(exp.metadata.id, exp)
  },
}

export default ExperienceRegistry
